import {
  FETCH_TAG_REQUEST,
  FETCH_TAG_SUCCESS,
  FETCH_TAG_FAILURE
} from 'actions/TagActions';

const initialState = {
  isFetching: false,
  tag: null
};

export default function tag(state = initialState, action) {
  switch (action.type) {
    case FETCH_TAG_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      });
    }
    case FETCH_TAG_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        tag: action.tag
      });
    }
    case FETCH_TAG_FAILURE: {
      return initialState;
    }
    default:
      return state;
  }
}
